import { useEffect, useState } from "react";

const breakpoints = {
  mobile: 768,
  tablet: 1024,
};

export const useResponsive = () => {
  const getDevice = () => ({
    isMobile: window.innerWidth < breakpoints.mobile,
    isTablet:
      window.innerWidth >= breakpoints.mobile &&
      window.innerWidth < breakpoints.tablet,
    isDesktop: window.innerWidth >= breakpoints.tablet,
  });

  const [device, setDevice] = useState(getDevice);

  useEffect(() => {
    const handleResize = () => setDevice(getDevice());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return device;
};
